import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'

export default {
  Title: 'Αναφορές',

  ReportsNotify: {
    Title: 'Ιστορικό Αναφορών',
    Table: {
      Headers: {
        Id        : '#',
        Type      : 'Τύπος',
        Range     : 'Περίοδος',
        Properties: 'Φίλτρα',
        User      : 'Χρήστης',
        Notify    : 'Ενέργεια',
        Download  : 'Αρχείο',
        CreatedAt : 'Ημερομηνία',
        Actions   : ''
      }
    },

    ConfirmDeleteDialog: {
      Title  : 'Διαγραφή Αναφοράς;',
      Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την αναφορά #{id}";',
      Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
    },

    Type: {
      orders: {
        Title     : 'Αναφορά Παραγγελιών',
        TitleColor: 'blue--text',
        Subtitle  : 'Αποστολή με Email'
      },
      orders_print: {
        Title     : 'Αναφορά Παραγγελιών',
        TitleColor: 'blue--text',
        Subtitle  : 'Εκτύπωση'
      },
      orders_download: {
        Title     : 'Αναφορά Παραγγελιών',
        TitleColor: 'blue--text',
        Subtitle  : 'Download'
      },

      receipts: {
        Title     : 'Αναφορά Παραστατικών (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Αποστολή με Email'
      },
      receipts_print: {
        Title     : 'Αναφορά Παραστατικών (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Εκτύπωση'
      },
      receipts_download: {
        Title     : 'Αναφορά Παραστατικών (Z)',
        TitleColor: 'orange--text',
        Subtitle  : 'Download'
      },

      sales_report: {
        Title     : 'Αναφορά Πωλήσεων',
        TitleColor: 'teal--text',
        Subtitle  : 'Αποστολή με Email'
      },

      fiscal_documents: {
        Title     : 'Παραστατικά',
        TitleColor: 'cyan--text',
        Subtitle  : 'Αποστολή με Email'
      },

      transactions: {
        Title     : 'Συναλλαγές EFT/POS',
        TitleColor: 'purple--text',
        Subtitle  : 'Αποστολή με Email'
      },

      statistics_products: {
        Title     : 'Στατιστικά Προϊόντων',
        TitleColor: 'green--text',
        Subtitle  : 'Αποστολή με Email'
      },
      statistics_products_download: {
        Title     : 'Στατιστικά Προϊόντων',
        TitleColor: 'green--text',
        Subtitle  : 'Download'
      },
      statistics_products_print: {
        Title     : 'Στατιστικά Προϊόντων',
        TitleColor: 'green--text',
        Subtitle  : 'Εκτύπωση'
      },

      products: {
        Title     : 'Προϊόντα Καταλόγου',
        TitleColor: 'blue-grey--text text--lighten-1',
        Subtitle  : 'Αποστολή με Email'
      },

      categories: {
        Title     : 'Κατηγορίες Καταλόγου',
        TitleColor: 'brown--text text--lighten-1',
        Subtitle  : 'Αποστολή με Email'
      }
    },

    Filter: {
      filterType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Τύπος',
        PlaceHolder: 'Όλοι οι τύποι',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Desc',
        Items      : [
          {
            Id    : 'orders_all',
            Name  : 'Αναφορά Παραγγελιών',
            Desc  : 'Όλοι οι τύποι',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders_print',
            Name  : 'Αναφορά Παραγγελιών',
            Desc  : 'Εκτύπωση',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders',
            Name  : 'Αναφορά Παραγγελιών',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'orders_download',
            Name  : 'Αναφορά Παραγγελιών',
            Desc  : 'Download PDF',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'receipts_all',
            Name  : 'Αναφορά Παραστατικών (Z)',
            Desc  : 'Όλοι οι τύποι',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts_print',
            Name  : 'Αναφορά Παραστατικών (Z)',
            Desc  : 'Εκτύπωση',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts',
            Name  : 'Αναφορά Παραστατικών (Z)',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },
          {
            Id    : 'receipts_download',
            Name  : 'Αναφορά Παραστατικών (Z)',
            Desc  : 'Download PDF',
            Avatar: {
              Color: 'orange',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'sales_report',
            Name  : 'Αναφορά Πωλήσεων',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'teal',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'fiscal_documents',
            Name  : 'Παραστατικά',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'cyan',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'transactions',
            Name  : 'Συναλλαγές EFT/POS',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'purple',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'statistics_products',
            Name  : 'Στατιστικά Προϊόντων',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'products',
            Name  : 'Προϊόντα Καταλόγου',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'blue-grey lighten-1',
              Icon : 'mdi-file-chart-outline'
            }
          },

          {
            Id    : 'categories',
            Name  : 'Κατηγορίες Καταλόγου',
            Desc  : 'Αποστολή με Email',
            Avatar: {
              Color: 'brown lighten-1',
              Icon : 'mdi-file-chart-outline'
            }
          }
        ]
      },

      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },

      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Ημερομηνία',
        PlaceHolder: 'Επιλέξτε Ημερομηνία',
        Icon       : 'event'
      }
    }
  },

  SalesReportReceiptsZ: {
    Title: 'Αναφορά Παραστατικών (Ζ)',
    Table: {
      Headers: {
        Source     : 'Πηγή',
        Order      : 'Παραγγελία',
        Receipt    : 'Παραστατικό',
        ReceiptType: 'Τύπος Παραστατικού',
        Total      : 'Σύνολο',
        Date       : 'Ημερομηνία'
      }
    },

    Export: {
      Title         : 'Εξαγωγή',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Σύντομα θα λάβετε την αναφορά στα email που επιλέξατε'
    },

    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Παραγγελίες',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Με Παραστατικό',
            Icon : 'mdi-receipt-text',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Χωρίς Παραστατικό',
            Icon : 'mdi-receipt-text-remove',
            Color: 'orange',
            Class: 'white--text'
          }
        ]
      },

      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Τύπος Παραστατικού',
        PlaceHolder: 'Όλοι οι τύποι παραστατικού',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : [
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
            Name  : 'Τιμολόγιο Πώλησης',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
            Name  : 'Πιστωτικό Τιμολόγιο / Συσχετιζόμενο',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
            Name  : 'Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
            Name  : 'Απόδειξη Λιανικής Πώλησης',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
            Name  : 'Απόδειξη Παροχής Υπηρεσιών',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
            Name  : 'Πιστωτικό Στοιχ. Λιανικής',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
            Name  : 'Δελτίο Παραγγελίας Εστίασης',
            Avatar: {
              Color: 'blue-grey',
              Icon : 'mdi-receipt-text'
            }
          }
        ]
      },

      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Πηγή Παραγγελίας',
        PlaceHolder: 'Όλες οι πηγές παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      }
    }
  }
}
